import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

interface SofiaV2LaunchContextValue {
  /** True once the welcome screen has shown long enough and the iframe may start loading. */
  startLoad: boolean;
  beginLoad: () => void;
  /** Set to true once the Sofia V2 iframe has finished loading its document. */
  iframeReady: boolean;
  notifyIframeReady: () => void;
  /** Reset the whole launch flow (both signals). */
  reset: () => void;
}

const SofiaV2LaunchContext = createContext<SofiaV2LaunchContextValue | null>(null);

export function SofiaV2LaunchProvider({ children }: { children: React.ReactNode }) {
  const [startLoad, setStartLoad] = useState(false);
  const [iframeReady, setIframeReady] = useState(false);

  const beginLoad = useCallback(() => setStartLoad(true), []);
  const notifyIframeReady = useCallback(() => setIframeReady(true), []);
  const reset = useCallback(() => {
    setStartLoad(false);
    setIframeReady(false);
  }, []);

  const value = useMemo(
    () => ({ startLoad, beginLoad, iframeReady, notifyIframeReady, reset }),
    [startLoad, beginLoad, iframeReady, notifyIframeReady, reset]
  );

  return <SofiaV2LaunchContext.Provider value={value}>{children}</SofiaV2LaunchContext.Provider>;
}

export function useSofiaV2Launch() {
  return useContext(SofiaV2LaunchContext);
}
